import { api } from "@/lib/api";

// Public API (no auth)
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const PUBLIC_BASE = `${BACKEND_URL}/api/v1/public`;

export const PublicAdmissionsAPI = {
  config: async (slug) => {
    const r = await fetch(`${PUBLIC_BASE}/tenants/${slug}/admissions/config`);
    if (!r.ok) throw await r.json().catch(() => ({ detail: "Failed" }));
    return r.json();
  },
  apply: async (body) => {
    const r = await fetch(`${PUBLIC_BASE}/admissions`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    });
    if (!r.ok) {
      const e = await r.json().catch(() => ({}));
      throw new Error(e.detail || `Failed (${r.status})`);
    }
    return r.json();
  },
};

export const AdmissionsAPI = {
  list: (params) => api.get("/admissions", { params }).then((r) => r.data),
  get: (id) => api.get(`/admissions/${id}`).then((r) => r.data),
  patch: (id, body) => api.patch(`/admissions/${id}`, body).then((r) => r.data),
  transition: (id, status, reason) => api.post(`/admissions/${id}/status`, { status, reason }).then((r) => r.data),
  note: (id, text) => api.post(`/admissions/${id}/notes`, { text }).then((r) => r.data),
  markFeePaid: (id, body) => api.post(`/admissions/${id}/fee/mark-paid`, body).then((r) => r.data),
  admit: (id, body) => api.post(`/admissions/${id}/admit`, body).then((r) => r.data),
};

export const APPLICATION_STATUSES = ["applied", "screening", "shortlisted", "admitted", "rejected", "withdrawn"];
